import { Atom, useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { METRIC_KEY } from '@/consts/searchKeys';
import { useRightPanelHeader } from '@/hooks/useRightPanelHeader/useRightPanelHeader';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { snakeToCamel } from '@/utils/queries';

export const useEntityVideoPlayerPanelHeader = (entityNameAtom: Atom<string>, entityIdParam: string) => {
  const { t } = useTranslation(['metrics', 'general']);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const metricKeyParam = searchParams.get(METRIC_KEY);
  const metricTranslationKey = metricKeyParam ? t(`${snakeToCamel(metricKeyParam)}.name`, { ns: 'metrics' }) : '';
  const entityName = useAtomValue(entityNameAtom);
  const title =
    entityName && metricTranslationKey ? `${entityName} - ${metricTranslationKey}` : t('loading', { ns: 'general' });

  const updateQueryString = useUpdateQueryString(searchParams);
  const onClose = () => navigate(`..?${updateQueryString([], [entityIdParam, METRIC_KEY])}`);

  useRightPanelHeader(title, onClose);
};
